// @ts-check

/**
 * @param {string} value
 * @returns {boolean}
 */
export function hasText(value) {
  return value.trim() !== "";
}

/**
 * @param {string} value
 * @returns {number}
 */
export function parseNumber(value) {
  const normalizedValue = value.replace(/\s+/g, "").replace(/,/g, ".").trim();
  if (normalizedValue === "") {
    return Number.NaN;
  }

  const result = Number(normalizedValue);
  if (!Number.isFinite(result)) {
    return Number.NaN;
  }

  return result;
}

/**
 * @param {string} value
 * @param {number} fallback
 * @returns {number}
 */
export function parseNumberOrDefault(value, fallback) {
  const parsedValue = parseNumber(value);
  if (!Number.isFinite(parsedValue)) {
    return fallback;
  }

  return parsedValue;
}

/**
 * @param {number} value
 * @param {number} digits
 * @returns {string}
 */
export function formatEnglishNumber(value, digits) {
  return value.toLocaleString("en-US", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

/**
 * @param {number} value
 * @param {number} digits
 * @returns {string}
 */
export function formatSpanishNumber(value, digits) {
  return value.toLocaleString("es-ES", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

/**
 * @param {number} value
 * @returns {string}
 */
export function formatEuroEs(value) {
  return `${formatSpanishNumber(value, 2)} €`;
}

/**
 * @param {string} text
 * @returns {Promise<void>}
 */
export async function copyTextToClipboard(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  textarea.style.pointerEvents = "none";
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();

  const successful = document.execCommand("copy");
  textarea.remove();
  if (!successful) {
    throw new Error("copy command failed");
  }
}
